export default __webpack_public_path__ + "static/media/abstract-retro-grunge-decorative-relief-with-film-dust-texture-blue-gradient-colors.87f75b93.jpg";